
import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table, Form, Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import { DatatableWrapper, TableBody, TableHeader } from "react-bs-datatable";
import { ShimmerTable } from "react-shimmer-effects";
import schoolApi from "../../api/schoolApi";
import CreateRolePermissionModal from "./CreateRolePermissionModal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import authApi from "../../api/authApi";
import jwtDecode from "jwt-decode";
import { Helmet } from "react-helmet";
import { id } from "date-fns/locale";

const RolePermissionList = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const [btnName, setBtnName] = useState("Save");
  const [rolePermissionData, setRolePermissionData] = useState();
  const [rolePermissions, setRolePermissions] = useState([]);
  const [upsertRolePermissions, setUpsertRolePermissions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [role, setRole] = useState();
  const [isAdminUser, setIsAdminUser] = useState(false);
  const [userInfo, setUserInfo] = useState();
  const [reports, setReports] = useState([]); //ADDED BBY MUSKAN KHAN\
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [readAllModuleCheck, setReadAllModuleCheck] = useState([]);
  const [readAllReportCheck, setReadAllReportCheck] = useState([]);

  const [tabCheckBox, setTabCheckBox] = useState({
    read_all: null,
    create_all: null,
    edit_all: null,
    delete_all: null,
    select_all_box: null,
  });
  const [tabCheckBoxx, setTabCheckBoxx] = useState({
    read_all: false, // Initialize as unchecked
  });
  useEffect(() => {
    fetchAllRoles();
    const token = sessionStorage.getItem("token");
    setUserInfo(jwtDecode(token));
  }, []);

  async function fetchAllRoles() {
    try {
      if (await authApi.companyDetail().companyid) {
        const rolePermissions = await schoolApi.getRolePermission(
          await authApi.companyDetail().companyid
        );

        setIsLoading(false);
        if (rolePermissions.success) {
          setRolePermissions(
            rolePermissions?.result?.filter(
              (rolePerission) => rolePerission.name !== "SYS_ADMIN"
            )
          );
        } else {
          setRolePermissions([]);
          toast.error(rolePermissions);
        }
      }
    } catch (error) {

      toast.error(error.response.data.message, {
        className: "toast-error",
      });
    }
  }

  useEffect(() => {}, [upsertRolePermissions]);

  const handleCheckBox = (columnName, row) => (e) => {
    const checked = e.target.checked;





    if (columnName === "select_all_box") {

      setTabCheckBox({
        read_all: checked,
        create_all: checked,
        edit_all: checked,
        delete_all: checked,
        select_all_box: checked,
      });

      setRolePermissions((oldRolePermissions) => {
        const updatedRolePermissions = oldRolePermissions.map((record) => {

          if (record.id === row.roleid) {












            const updatedPermissions = record.permissions.map((item) => {
              if (!item.module_name.includes("Report")) {
                return {
                  ...item,
                  can_read: checked,
                  can_create: checked,
                  can_edit: checked,
                  can_delete: checked,
                };
              }
              return item; // "Report" wale permissions unchanged rahenge
            });

            setUpsertRolePermissions(updatedPermissions);
            return { ...record, permissions: updatedPermissions };
          }
          return record;
        });

        return updatedRolePermissions;
      });

      if (e.target.id === "Report Module") {
        setReadAllReportCheck(checked);
      }
      if (e.target.id === "Module") {
        setReadAllModuleCheck(checked);
      }
    } else if (
      columnName === "read_all" ||
      columnName === "create_all" ||
      columnName === "edit_all" ||
      columnName === "delete_all"
    ) {

      if (row.module_name === "Report Module") {

        setReadAllReportCheck(checked);
      }
      if (row.module_name === "Module") {

        setReadAllModuleCheck(checked);
      }


      if (columnName === "read_all")
        setTabCheckBox((prev) => ({ ...prev, read_all: checked }));
      else if (columnName === "create_all"){

        setTabCheckBox((prev) => ({ ...prev, create_all: checked }));

      }
      else if (columnName === "edit_all"){

        setTabCheckBox((prev) => ({ ...prev, edit_all: checked }));
      }
      else{

        setTabCheckBox((prev) => ({ ...prev, delete_all: checked }));
      }

      setRolePermissions((oldRolePermissions) => {
        const updatedRolePermissions = [...oldRolePermissions];
        let roleData = updatedRolePermissions.find(
          (record) => record.id === row.roleid
        );
        const reportsData = roleData.permissions.filter((res) =>
          res.module_name.includes("Report")
        );





        const filteredReports = reports.filter((report) =>
          updatedRolePermissions.some(
            (permission) => permission.moduleid === report.moduleid
          )
        );


        if (row.module_name === "Report Module") {
          const rolePermission = reportsData.map((item) => {
            if (columnName === "read_all") item.can_read = e.target.checked;
          });
        } else {
          const rolePermission = roleData.permissions.map((item) => {
            if (!item.module_name.includes("Report")) {
              if (columnName === "read_all") item.can_read = e.target.checked;
              else if (columnName === "create_all"){
                item.can_read = e.target.checked;
                item.can_create = e.target.checked;
              }
              else if (columnName === "edit_all"){
                item.can_read = e.target.checked;
                item.can_edit = e.target.checked;
              }
              else if (columnName === "delete_all"){
                item.can_read = e.target.checked;
                item.can_delete = e.target.checked;
              }
                
            }
          });
        }

        setUpsertRolePermissions(roleData.permissions);
        return updatedRolePermissions;
      });
    } else {
      setRolePermissions((oldRolePermissions) => {
        const updatedRolePermissions = [...oldRolePermissions];
        const roleData = updatedRolePermissions.find(
          (record) => record.id === row.roleid
        );

        const rolePermission = roleData.permissions.find(
          (perm) => perm.moduleid === row.moduleid
        );
        if (!rolePermission) return updatedRolePermissions;

        if (
          ["can_read", "can_create", "can_edit", "can_delete"].includes(
            columnName
          )
        ) {
          rolePermission[columnName] = checked;

          if (["can_create", "can_edit", "can_delete"].includes(columnName) && checked) {
            rolePermission.can_read = true;
            if (roleData.permissions.every((perm) => perm.can_read === true)) {
              setTabCheckBox((prev) => ({ ...prev, read_all: true }));
            }
          }
          if (["can_read"].includes(columnName) && !checked) {
            rolePermission.can_create = false;
            rolePermission.can_edit = false;
            rolePermission.can_delete = false;
          }
        }


        if (columnName === "select_all") {
          rolePermission.can_edit = checked;
          rolePermission.can_create = checked;
          rolePermission.can_read = checked;
          rolePermission.can_delete = checked;

          const isAllPemissions = roleData.permissions?.every(
            (permission) =>
              permission.can_read === true &&
              permission.can_create === true &&
              permission.can_edit === true &&
              permission.can_delete === true
          );


          if (isAllPemissions) {
            setTabCheckBox({
              read_all: true,
              create_all: true,
              edit_all: true,
              delete_all: true,
              select_all_box: true,
            });
          } else {
            setTabCheckBox({
              read_all: roleData.permissions.every(
                (perm) => perm.can_read === true
              ),
              create_all: roleData.permissions.every(
                (perm) => perm.can_create === true
              ),
              edit_all: roleData.permissions.every(
                (perm) => perm.can_edit === true
              ),
              delete_all: roleData.permissions.every(
                (perm) => perm.can_delete === true
              ),
            });
          }
        }


        rolePermission.select_all = [
          "can_edit",
          "can_create",
          "can_read",
          "can_delete",
        ].every((perm) => rolePermission[perm]);

        roleData.permissions.every((perm) => perm.can_read === true)
          ? setTabCheckBox((prev) => ({ ...prev, read_all: true }))
          : setTabCheckBox((prev) => ({ ...prev, read_all: false }));
        roleData.permissions.every((perm) => perm.can_create === true)
          ? setTabCheckBox((prev) => ({ ...prev, create_all: true }))
          : setTabCheckBox((prev) => ({ ...prev, create_all: false }));
        roleData.permissions.every((perm) => perm.can_edit === true)
          ? setTabCheckBox((prev) => ({ ...prev, edit_all: true }))
          : setTabCheckBox((prev) => ({ ...prev, edit_all: false }));
        roleData.permissions.every((perm) => perm.can_delete === true)
          ? setTabCheckBox((prev) => ({ ...prev, delete_all: true }))
          : setTabCheckBox((prev) => ({ ...prev, delete_all: false }));



        const checkReadAll = roleData.permissions.every(
          (perm) => perm.can_read === true
        )
          ? true
          : false;

        if (checkReadAll) {
          if (e.target.id === "Report Module") {
            setReadAllReportCheck(checkReadAll);
          }
          if (e.target.id === "Module") {
            setReadAllModuleCheck(checkReadAll);
          }
        } else {


          if (e.target.id === "Report Module") {
            const reportsData = roleData.permissions.filter((res) =>
              res.module_name.includes("Report")
            );
            const checkReadAllReport = reportsData.every(
              (perm) => perm.can_read === true
            )
              ? true
              : false;

            setReadAllReportCheck(checkReadAllReport);


          }
          if (e.target.id === "Module") {
            const permData = roleData.permissions.filter((res) =>
              !res.module_name.includes("Report")
            );
            const checkReadAllModule = permData.every(
              (perm) => perm.can_read === true
            )
              ? true
              : false;
            
            setReadAllModuleCheck(checkReadAllModule);
          }
        }


        const upsertIndex = upsertRolePermissions.findIndex(
          (record) =>
            record.roleid === row.roleid && record.moduleid === row.moduleid
        );
        const newUpsertPermissions = upsertRolePermissions.slice();
        if (upsertIndex > -1) {
          newUpsertPermissions[upsertIndex] = rolePermission; // Update existing record
        } else {
          newUpsertPermissions.push(rolePermission); // Add new record
        }

        setUpsertRolePermissions(newUpsertPermissions);
        return updatedRolePermissions;
      });
    }
  };







  const header = [
    { title: "Module", prop: "module_name", isFilterable: true },
    {
      title: (
        <span>
          Read
          <Form.Check
            disabled={isAdminUser}
            type="checkbox"
            onChange={handleCheckBox("read_all", {
              roleid: role,
              module_name: "Module",
            })}
            checked={



                rolePermissions?.some(
                    (userRole) =>
                      userRole?.id === role &&
                      userRole?.permissions
                      ?.filter((permission) => !permission.module_name.includes("Report"))
                      ?.every((permission) => permission?.can_read === true))
            }
          />
        </span>
      ),
      prop: "can_read",
      isFilterable: true,
      cell: (row) =>
        row.can_read &&
        (row?.can_create || row?.can_edit || row?.can_delete) ? (
          <Form.Check
            id="Module"
            disabled={isAdminUser}
            type="checkbox"
            onChange={handleCheckBox("can_read", row)}
            checked={
              row.can_read ||
              row?.can_create ||
              row?.can_edit ||
              row?.can_delete
            }
          />
        ) : (
          <Form.Check
            id="Module"
            disabled={isAdminUser}
            type="checkbox"
            onChange={handleCheckBox("can_read", row)}
            checked={row.can_read}
          />
        ),
    },
    {
      title: (
        <span>
          Create
          <Form.Check
            disabled={isAdminUser}
            type="checkbox"
            onChange={handleCheckBox("create_all", { roleid: role })}
            checked={



                rolePermissions.some(
                    (userRole) =>
                      userRole?.id === role &&
                      userRole?.permissions
                      ?.filter((permission) => !permission.module_name.includes("Report"))
                      ?.every(
                        (permission) => permission?.can_create === true
                      )
                  )
            }
          />
        </span>
      ),
      prop: "can_create",
      isFilterable: true,
      cell: (row) => (
        <Form.Check
          disabled={isAdminUser || row.module_name.includes("Report")}
          type="checkbox"
          onChange={handleCheckBox("can_create", row)}
          checked={row.module_name.includes("Report") ? false : row.can_create}
        />
      ),
    },
    {
      title: (
        <span>
          Edit
          <Form.Check
            disabled={isAdminUser}
            type="checkbox"
            onChange={handleCheckBox("edit_all", { roleid: role })}
            checked={



                rolePermissions?.some(
                    (userRole) =>
                      userRole?.id === role &&
                      userRole?.permissions
                      ?.filter((permission) => !permission.module_name.includes("Report"))
                      ?.every(
                        (permission) => permission?.can_edit === true
                      )
                  )
            }
          />
        </span>
      ),
      prop: "can_edit",
      isFilterable: true,
      cell: (row) => (
        <Form.Check
          disabled={isAdminUser}
          type="checkbox"
          onChange={handleCheckBox("can_edit", row)}
          checked={row.can_edit}
        />
      ),
    },
    {
      title: (
        <>
          Delete
          <Form.Check
            disabled={isAdminUser}
            type="checkbox"
            onChange={handleCheckBox("delete_all", { roleid: role })}
            checked={



                rolePermissions?.some(
                    (userRole) =>
                      userRole?.id === role &&
                      userRole?.permissions?.filter((permission) => !permission.module_name.includes("Report"))
                      ?.every(
                        (permission) => permission?.can_delete === true
                      )
                  )
            }
          />
        </>
      ),
      prop: "can_delete",
      isFilterable: true,
      cell: (row) => (
        <Form.Check
          disabled={isAdminUser}
          type="checkbox"
          onChange={handleCheckBox("can_delete", row)}
          checked={row.can_delete}
        />
      ),
    },
    {
      title: (
        <>
          Select All
          <Form.Check
            id="Module"
            disabled={isAdminUser}
            type="checkbox"
            onChange={handleCheckBox("select_all_box", { roleid: role })}
            checked={




              rolePermissions?.some(
                (userRole) =>
                  userRole?.id === role &&
                  userRole?.permissions
                  ?.filter((permission) => !permission.module_name.includes("Report"))
                  ?.every(
                    (permission) =>
                      (permission?.can_read === true || readAllModuleCheck) &&
                      permission?.can_create === true &&
                      permission?.can_edit === true &&
                      permission?.can_delete === true
                  )
              )
            }
          />
        </>
      ),
      prop: "select_all",
      isFilterable: true,
      cell: (row) => (
        <Form.Check
          id="Module"
          disabled={isAdminUser}
          type="checkbox"
          onChange={handleCheckBox("select_all", row)}
          checked={
            row.can_create && row?.can_read && row?.can_edit && row?.can_delete
          }
        />
      ),
    },
  ];



  const header2 = [
    { title: "Report Module", prop: "module_name", isFilterable: true },
    {
      title: (
        <span>
          Read
          <Form.Check
            disabled={isAdminUser}
            type="checkbox"
            onChange={handleCheckBox("read_all", {
              roleid: role,
              module_name: "Report Module",
            })}
            checked={



              rolePermissions?.some(
                (userRole) =>
                  userRole?.id === role &&
                  userRole?.permissions
                  ?.filter((permission) => permission.module_name.includes("Report")) // Only check "Report" data
                  ?.every((permission) => permission?.can_read === true) // Check if all reports have can_read = true
                )
            }











          />
        </span>
      ),
      prop: "can_read",
      isFilterable: true,
      cell: (row) =>
        row.can_read &&
        (row?.can_create || row?.can_edit || row?.can_delete) ? (
          <Form.Check
            id="Report Module"
            disabled={isAdminUser}
            type="checkbox"
            onChange={handleCheckBox("can_read", row)}
            checked={
              row.can_read ||
              row?.can_create ||
              row?.can_edit ||
              row?.can_delete
            }
          />
        ) : (
          <Form.Check
            id="Report Module"
            disabled={isAdminUser}
            type="checkbox"
            onChange={handleCheckBox("can_read", row)}
            checked={row.can_read}
          />
        ),
    },
    {
      title: (
        <span>
          Create
          <Form.Check
            disabled={true}
            type="checkbox"
            onChange={handleCheckBox("create_all", { roleid: role })}
            checked={false}
          />
        </span>
      ),
      prop: "can_create",
      isFilterable: true,
      cell: (row) => (
        <Form.Check
          disabled={true}
          type="checkbox"
          onChange={handleCheckBox("can_create", row)}
          checked={false}
        />
      ),
    },
    {
      title: (
        <span>
          Edit
          <Form.Check
            disabled={true}
            type="checkbox"
            onChange={handleCheckBox("edit_all", { roleid: role })}
            checked={false}
          />
        </span>
      ),
      prop: "can_edit",
      isFilterable: true,
      cell: (row) => (
        <Form.Check
          disabled={true}
          type="checkbox"
          onChange={handleCheckBox("can_edit", row)}
          checked={false}
        />
      ),
    },
    {
      title: (
        <>
          Delete
          <Form.Check
            disabled={true}
            type="checkbox"
            onChange={handleCheckBox("delete_all", { roleid: role })}
            checked={false}
          />
        </>
      ),
      prop: "can_delete",
      isFilterable: true,
      cell: (row) => (
        <Form.Check
          disabled={true}
          type="checkbox"
          onChange={handleCheckBox("can_delete", row)}
          checked={false}
        />
      ),
    },
    {
      title: (
        <>
          Select All
          <Form.Check
            id="Report Module"
            disabled={true}
            type="checkbox"
            onChange={handleCheckBox("select_all_box", { roleid: role })}
            checked={false}
          />
        </>
      ),
      prop: "select_all",
      isFilterable: true,
      cell: (row) => (
        <Form.Check
          id="Report Module"
          disabled={true}
          type="checkbox"
          onChange={handleCheckBox("select_all", row)}
          checked={false}
        />
      ),
    },
  ];
  const handleCloseModal = () => {
    setModalShow(false);
  };

  const handleSaveChanges = async (e) => {
    try {
      const result = await schoolApi.upsertRolePermissions(
        upsertRolePermissions
      );

      if (result.success) {
        toast.success("Record updated successfully");
      } else {
        toast.error("Record not updated..!!", {
          className: "toast-error",
        });
      }
    } catch (error) {

      toast.error(error.response.data.message, {
        className: "toast-error",
      });
    }
  };



  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <CreateRolePermissionModal
        modalShow={modalShow}
        handleCloseModal={handleCloseModal}
        fetchAllRolePermissions={fetchAllRoles}
        rolePermissionData={rolePermissionData}
        btnName={btnName}
      />

      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Col lg={2} className="m-4">
        <Link className="nav-link" to="/">
          Home <i className="fa-solid fa-chevron-right"></i> Role Permission
        </Link>
      </Col>

      <Row className="g-0">
        <Col lg={12} className="px-lg-4">
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <div style={{ backgroundColor: "#CFE2FF", padding: "15px" }}>
                <div style={{ fontSize: "15px", paddingLeft: "10px" }}>
                  Role Permission
                </div>
              </div>
              {isLoading ? (
                <div className="loader"></div>
              ) : (
                <div>
                  <Accordion.Body>
                    {rolePermissions ? (
                      <Accordion defaultActiveKey="0" className="container">
                        {rolePermissions?.map((role, index) => (
                          <Accordion.Item key={role.roleid} eventKey={index}>
                            {
                              <Accordion.Header
                                onClick={(e) => {
                                  setRole(role.id);
                                  userInfo.userrole === "ADMIN" &&
                                  role.name === "ADMIN"
                                    ? setIsAdminUser(true)
                                    : setIsAdminUser(false);
                                }}
                              >
                                {role.name}
                              </Accordion.Header>
                            }
                            <Accordion.Body>
                              <DatatableWrapper
                                headers={header}
                                key={role.roleid}
                                body={role.permissions.filter(
                                  (res) => !res.module_name.includes("Report")
                                )}
                              >
                                <Table className="data-table">
                                  <TableHeader />
                                  <TableBody />
                                </Table>
                              </DatatableWrapper>

                              <DatatableWrapper
                                headers={header2}
                                key={role.roleid}
                                body={role.permissions.filter((res) =>
                                  res.module_name.includes("Report")
                                )}
                              >
                                <Table className="data-table">
                                  <TableHeader />
                                  <TableBody />
                                </Table>
                              </DatatableWrapper>
                            </Accordion.Body>
                          </Accordion.Item>
                        ))}
                      </Accordion>
                    ) : (
                      <ShimmerTable row={10} col={8} />
                    )}

                    <div className="row">
                      <div className="col-sm-6 col-md-11"></div>
                      <div className="col-6 col-md-1">
                        <Button
                          className="btn-sm my-3 py-2 px-3  ms-4"
                          variant="primary"
                          onClick={handleSaveChanges}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  </Accordion.Body>
                </div>
              )}
            </Accordion.Item>
          </Accordion>
        </Col>
        <Col lg={2}></Col>
      </Row>
    </>
  );
};
export default RolePermissionList;
















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































